// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* buttons */

.help-desk-close-webchat-content {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  align-items: center;
}

.help-desk-close-webchat-content .button-margin {
  margin-right: 8px;
  margin-bottom: 8px;
}

.help-desk-close-button, .help-desk-continue-button {
  height: 40px;
  font-size: 13px;
  line-height: 40px;
  pointer-events: auto;
  cursor: pointer;
  text-align: center;
  background: linear-gradient(135deg, rgb(36, 44, 52) 0%, rgb(20, 68, 95) 100%);
  color: rgb(255, 255, 255);
  border-radius: 40px;
  padding: 0px 12px;
  transition: color 0.3s ease 0s, background-color 0.3s ease 0s;
}

.help-desk-close-button:disabled, .help-desk-continue-button:disabled {
  opacity: 0.5;
}

.help-desk-close-button:hover, .help-desk-continue-button:hover {
  background: linear-gradient(135deg, rgb(60, 72, 85) 0%, rgb(31, 97, 136) 100%);
}

.help-desk-close-button-content, .help-desk-continue-button-content {
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
}

.help-desk-close-button-content-svg, .help-desk-continue-button-content-svg {
  width: 15px;
  height: 16px;
}

.help-desk-close-button-content-svg path, .help-desk-continue-button-content-svg path {
  fill: rgb(255, 255, 255);
}

.help-desk-close-button-content span, .help-desk-continue-button-content span {
  white-space: nowrap;
  font-weight: 600;
}


/* Chat Messages */

.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-x: hidden;
  overflow-y: scroll;
  outline-offset: -5px;
}

.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper {
  display: flex;
  flex-direction: column;
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-shrink: 0;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: auto;
  position: relative;
}

.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper .help-desk-conversation-transfrom {
  opacity: 1;
  transform: translateX(0px);
  animation-name: animation-1l7dfs7;
  animation-duration: 320ms;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-delay: 230ms;
  animation-fill-mode: backwards;
}

.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper .help-desk-conversation-content {
  display: flex;
  padding: 24px 24px 0px;
  flex-flow: row wrap;
  transition: transform 200ms ease 0s;
}

.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper .help-desk-conversation-content > * {
  max-width: 100%;
  flex: 1 1 100%;
}

.help-desk-conversation-message {
  padding-bottom: 24px;
}

.help-desk-conversation-message-left {
  position: relative;
  text-align: left;
  float: left;
  padding-left: 45px;
  width: calc(100% - 48px);
}

.help-desk-avatar-message {
  position: absolute;
  left: 0px;
  bottom: 10px;
}

.help-desk-avatar-message  .help-desk-avatar-image {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  margin: 0px auto;
  border-radius: 50%;
  padding: 5px;
}

.help-desk-avatar-message  .help-desk-avatar-image img {
  width: 32px;
  height: 32px;
}

.help-desk-avatar-message  .help-desk-avatar-image img {
  border-radius: 50%;
}

.help-desk-comment-support {
  position: relative;
  display: inline-block;
  width: auto;
  /* max-width: 75%; */
  color: rgb(0, 0, 0);
  background-color: rgb(245, 245, 245);
  padding: 17px 20px;
  border-radius: 5px;
}

.help-desk-comment .help-desk-block-paragraph-support, .e1d9qmys0 .help-desk-block-paragraph-support, .e8bmhyr0 .help-desk-block-paragraph-support {
  font-size: 14px;
  line-height: 1.4;
  margin: 0px 0px 10px;
}

.help-desk-block-paragraph-support {
  overflow-wrap: break-word;
  word-break: break-word;
}

.help-desk-comment .help-desk-block-paragraph-support a {
  color: #039be5;
  text-decoration: none;
}

.help-desk-comment .help-desk-block-paragraph-support a svg {
  width: 18px;
  height: 18px;
  position: relative;
  top: 2px;
}

.help-desk-conversation-message-right {
  position: relative;
  text-align: left;
  float: right;
  padding-left: 48px;
  width: calc(100% - 48px);
}

.help-desk-comment-customer {
  position: relative;
  width: auto;
  max-width: 75%;
  color: rgb(255, 255, 255);
  background: linear-gradient(135deg, rgb(36, 44, 52) 0%, rgb(20, 68, 95) 100%);
  float: right;
  padding: 17px 20px;
  border-radius: 5px;
}

.help-desk-comment .help-desk-block-paragraph-customer, .e1d9qmys0 .help-desk-block-paragraph-customer, .e8bmhyr0 .help-desk-block-paragraph-customer {
  font-size: 14px;
  line-height: 1.4;
  margin: 0px 0px 10px;
}

.help-desk-block-paragraph-customer:last-child {
  margin-bottom: 0px !important;
}

.help-desk-block-paragraph-customer {
  overflow-wrap: break-word;
  word-break: break-word;
}

.help-desk-comment .help-desk-block-paragraph-customer a {
  color: rgb(255, 255, 255);
  text-decoration: none;
}

.help-desk-comment .help-desk-block-paragraph-customer a svg {
  width: 18px;
  height: 18px;
  position: relative;
  top: 2px;
}


.help-desk-prompt-container {

  /* Arrange buttons in a column */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Use 'center' to center buttons if desired */
  gap: 12px;             /* Space between buttons */
  /* You can add margin or padding if you need additional spacing */
}

.help-desk-prompt-button {
  /* Remove default browser styles for buttons */
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;

  /* Set font properties (adjust as needed for your project) */
  font-size: 1rem;
  font-family: sans-serif;

  /* Set text color and border color */
  color: #8e44ad;            /* Purple */
  border: 2px solid #8e44ad;  /* Purple border with 2px width */
  
  /* Add padding inside the button */
  padding: 10px 20px;
  
  /* Create a pill-shaped button with fully rounded edges */
  border-radius: 9999px;
  
  /* Optional: Ensure no default margin interferes */
  margin: 0;
}

.help-desk-prompt-button:hover {
  /* Hover effect: change background and text colors */
  background-color: #8e44ad;
  color: #fff;
}

.help-desk-prompt-button:active {
  /* Active effect: slight scaling and opacity change for click feedback */
  transform: scale(0.98);
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./dist/src/components/controls/conversation/conversation.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,6EAA6E;EAC7E,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;EACzB,yDAAyD;EACzD,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,6EAA6E;EAC7E,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;;AAGA;;EAEE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,8CAA8C;EACvE,SAAS,cAAc,0BAA0B;EACjD,iEAAiE;AACnE;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;;EAEf,4DAA4D;EAC5D,eAAe;EACf,uBAAuB;;EAEvB,oCAAoC;EACpC,cAAc,aAAa,WAAW;EACtC,yBAAyB,GAAG,iCAAiC;;EAE7D,kCAAkC;EAClC,kBAAkB;;EAElB,yDAAyD;EACzD,qBAAqB;;EAErB,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,YAAY;AACd","sourcesContent":["/* buttons */\r\n\r\n.help-desk-close-webchat-content {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.help-desk-close-webchat-content .button-margin {\r\n  margin-right: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.help-desk-close-button, .help-desk-continue-button {\r\n  height: 40px;\r\n  font-size: 13px;\r\n  line-height: 40px;\r\n  pointer-events: auto;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  background: linear-gradient(135deg, rgb(36, 44, 52) 0%, rgb(20, 68, 95) 100%);\r\n  color: rgb(255, 255, 255);\r\n  border-radius: 40px;\r\n  padding: 0px 12px;\r\n  transition: color 0.3s ease 0s, background-color 0.3s ease 0s;\r\n}\r\n\r\n.help-desk-close-button:disabled, .help-desk-continue-button:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n.help-desk-close-button:hover, .help-desk-continue-button:hover {\r\n  background: linear-gradient(135deg, rgb(60, 72, 85) 0%, rgb(31, 97, 136) 100%);\r\n}\r\n\r\n.help-desk-close-button-content, .help-desk-continue-button-content {\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.help-desk-close-button-content-svg, .help-desk-continue-button-content-svg {\r\n  width: 15px;\r\n  height: 16px;\r\n}\r\n\r\n.help-desk-close-button-content-svg path, .help-desk-continue-button-content-svg path {\r\n  fill: rgb(255, 255, 255);\r\n}\r\n\r\n.help-desk-close-button-content span, .help-desk-continue-button-content span {\r\n  white-space: nowrap;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n/* Chat Messages */\r\n\r\n.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  outline-offset: -5px;\r\n}\r\n\r\n.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  -webkit-box-flex: 1;\r\n  flex-grow: 1;\r\n  flex-shrink: 0;\r\n  -webkit-box-pack: justify;\r\n  justify-content: space-between;\r\n  height: auto;\r\n  position: relative;\r\n}\r\n\r\n.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper .help-desk-conversation-transfrom {\r\n  opacity: 1;\r\n  transform: translateX(0px);\r\n  animation-name: animation-1l7dfs7;\r\n  animation-duration: 320ms;\r\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n  animation-delay: 230ms;\r\n  animation-fill-mode: backwards;\r\n}\r\n\r\n.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper .help-desk-conversation-content {\r\n  display: flex;\r\n  padding: 24px 24px 0px;\r\n  flex-flow: row wrap;\r\n  transition: transform 200ms ease 0s;\r\n}\r\n\r\n.help-desk-content-body .help-desk-conversation-wrapper .help-desk-conversation-body .help-desk-conversation-body-parts .help-desk-conversation-body-parts-wrapper .help-desk-conversation-content > * {\r\n  max-width: 100%;\r\n  flex: 1 1 100%;\r\n}\r\n\r\n.help-desk-conversation-message {\r\n  padding-bottom: 24px;\r\n}\r\n\r\n.help-desk-conversation-message-left {\r\n  position: relative;\r\n  text-align: left;\r\n  float: left;\r\n  padding-left: 45px;\r\n  width: calc(100% - 48px);\r\n}\r\n\r\n.help-desk-avatar-message {\r\n  position: absolute;\r\n  left: 0px;\r\n  bottom: 10px;\r\n}\r\n\r\n.help-desk-avatar-message  .help-desk-avatar-image {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 32px;\r\n  height: 32px;\r\n  line-height: 32px;\r\n  font-size: 16px;\r\n  margin: 0px auto;\r\n  border-radius: 50%;\r\n  padding: 5px;\r\n}\r\n\r\n.help-desk-avatar-message  .help-desk-avatar-image img {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.help-desk-avatar-message  .help-desk-avatar-image img {\r\n  border-radius: 50%;\r\n}\r\n\r\n.help-desk-comment-support {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: auto;\r\n  /* max-width: 75%; */\r\n  color: rgb(0, 0, 0);\r\n  background-color: rgb(245, 245, 245);\r\n  padding: 17px 20px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.help-desk-comment .help-desk-block-paragraph-support, .e1d9qmys0 .help-desk-block-paragraph-support, .e8bmhyr0 .help-desk-block-paragraph-support {\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  margin: 0px 0px 10px;\r\n}\r\n\r\n.help-desk-block-paragraph-support {\r\n  overflow-wrap: break-word;\r\n  word-break: break-word;\r\n}\r\n\r\n.help-desk-comment .help-desk-block-paragraph-support a {\r\n  color: #039be5;\r\n  text-decoration: none;\r\n}\r\n\r\n.help-desk-comment .help-desk-block-paragraph-support a svg {\r\n  width: 18px;\r\n  height: 18px;\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n.help-desk-conversation-message-right {\r\n  position: relative;\r\n  text-align: left;\r\n  float: right;\r\n  padding-left: 48px;\r\n  width: calc(100% - 48px);\r\n}\r\n\r\n.help-desk-comment-customer {\r\n  position: relative;\r\n  width: auto;\r\n  max-width: 75%;\r\n  color: rgb(255, 255, 255);\r\n  background: linear-gradient(135deg, rgb(36, 44, 52) 0%, rgb(20, 68, 95) 100%);\r\n  float: right;\r\n  padding: 17px 20px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.help-desk-comment .help-desk-block-paragraph-customer, .e1d9qmys0 .help-desk-block-paragraph-customer, .e8bmhyr0 .help-desk-block-paragraph-customer {\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  margin: 0px 0px 10px;\r\n}\r\n\r\n.help-desk-block-paragraph-customer:last-child {\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\n.help-desk-block-paragraph-customer {\r\n  overflow-wrap: break-word;\r\n  word-break: break-word;\r\n}\r\n\r\n.help-desk-comment .help-desk-block-paragraph-customer a {\r\n  color: rgb(255, 255, 255);\r\n  text-decoration: none;\r\n}\r\n\r\n.help-desk-comment .help-desk-block-paragraph-customer a svg {\r\n  width: 18px;\r\n  height: 18px;\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n\r\n.help-desk-prompt-container {\r\n\r\n  /* Arrange buttons in a column */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start; /* Use 'center' to center buttons if desired */\r\n  gap: 12px;             /* Space between buttons */\r\n  /* You can add margin or padding if you need additional spacing */\r\n}\r\n\r\n.help-desk-prompt-button {\r\n  /* Remove default browser styles for buttons */\r\n  appearance: none;\r\n  border: none;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n\r\n  /* Set font properties (adjust as needed for your project) */\r\n  font-size: 1rem;\r\n  font-family: sans-serif;\r\n\r\n  /* Set text color and border color */\r\n  color: #8e44ad;            /* Purple */\r\n  border: 2px solid #8e44ad;  /* Purple border with 2px width */\r\n  \r\n  /* Add padding inside the button */\r\n  padding: 10px 20px;\r\n  \r\n  /* Create a pill-shaped button with fully rounded edges */\r\n  border-radius: 9999px;\r\n  \r\n  /* Optional: Ensure no default margin interferes */\r\n  margin: 0;\r\n}\r\n\r\n.help-desk-prompt-button:hover {\r\n  /* Hover effect: change background and text colors */\r\n  background-color: #8e44ad;\r\n  color: #fff;\r\n}\r\n\r\n.help-desk-prompt-button:active {\r\n  /* Active effect: slight scaling and opacity change for click feedback */\r\n  transform: scale(0.98);\r\n  opacity: 0.9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
